import { createAction, props } from '@ngrx/store';
import { InputFieldPropertyState } from '../input-field-properties-collection.state';

/**
 * Dispatched by `InputFieldPropertiesNgrxService.init()` to load the properties from the backend
 * (also re-run on sync completion).
 */
export const initInputFieldProperties = createAction('[InputFieldProperties] Init');

/**
 * Dispatched once the backend input field properties have been loaded. Replaces the slice's
 * properties in full and marks it as {@link LoadStatus.Loaded}.
 */
export const inputFieldPropertiesLoaded = createAction(
    '[InputFieldProperties] Loaded',
    props<{ properties: InputFieldPropertyState[] }>(),
);

/**
 * Dispatched when the offline cache is read back at startup. Populates the slice identically to
 * {@link inputFieldPropertiesLoaded}; the two are distinct actions only so the persist effect
 * fires for the backend load and not for the rehydrate.
 */
export const inputFieldPropertiesLoadedFromStorage = createAction(
    '[InputFieldProperties] Loaded From Storage',
    props<{ properties: InputFieldPropertyState[] }>(),
);

/**
 * Dispatched by the load effect when the backend request fails. Transitions the slice to
 * {@link LoadStatus.Error} so the facade's `init()` observable can surface the failure.
 */
export const inputFieldPropertiesFailed = createAction('[InputFieldProperties] Failed');
